module.exports = ".nav-link {\r\n    border-radius: 31px;\r\n    width: 50px;\r\n    text-align: center;\r\n    height: 50px;\r\n    padding: 11px 9px;\r\n    font-size: 20px;\r\n    border: 5px solid #29b1e5;\r\n    background-color: #0c8ec2;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 410
// module chunks = 0